export type TooltipUserGuideEntityName =
    'firstStep'
    | 'bucket'
    | 'shardRepository'
    | 'shardCluster'
    | 'accessCredentials'
    | 'storageProvider';

export const tooltipUserGuideEntityOrder: TooltipUserGuideEntityName[] = [
    'firstStep',
    'shardRepository',
    'shardCluster',
    'bucket',
    'accessCredentials'
];

export const tooltipUserGuideVisibleEntityOrder: TooltipUserGuideEntityName[] = [
    'shardRepository',
    'shardCluster',
    'bucket',
    'accessCredentials'
];

export enum TooltipUserGuideActionType {
    Open = "TOOLTIP_USER_GUIDE_OPEN",
    Close = "TOOLTIP_USER_GUIDE_CLOSE",

    NextStep = "TOOLTIP_USER_GUIDE_NEXT_STEP",
    PreviousStep = "TOOLTIP_USER_GUIDE_PREVIOUS_STEP",

    SetStep = "TOOLTIP_USER_GUIDE_SET_STEP",

    EnableStepCounter = "TOOLTIP_USER_GUIDE_ENABLE_STEP_COUNTER",
    DisableStepCounter = "TOOLTIP_USER_GUIDE_DISABLE_STEP_COUNTER",
}

class TooltipUserGuideActions {

    open() {
        return {
            type: TooltipUserGuideActionType.Open
        };
    }

    close() {
        return {
            type: TooltipUserGuideActionType.Close
        };
    }

    enableStepCounter() {
        return {
            type: TooltipUserGuideActionType.EnableStepCounter
        };
    }

    disableStepCounter() {
        return {
            type: TooltipUserGuideActionType.DisableStepCounter
        };
    }

    nextStep() {
        return {
            type: TooltipUserGuideActionType.NextStep
        };
    }

    previousStep() {
        return {
            type: TooltipUserGuideActionType.PreviousStep
        };
    }

    setStep(entityName: TooltipUserGuideEntityName) {
        return {
            type: TooltipUserGuideActionType.SetStep,
            payload: {
                entityName
            }
        };
    }
}

export const tooltipUserGuideActions = new TooltipUserGuideActions();